import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { GamificationService } from '../services/gamification.service';
import { Subject } from 'rxjs';
import { formatDate } from '@angular/common';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: '',
  template: '',
})
export class GamificationRequestHandler extends BaseSearchComponent<GamificationService> implements OnInit {
  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  showTable = false;
  headers = [];
  filteredData = [];
  filterType = '';
  rankType = '';
  rankCount: number;
  submitted: boolean;
  arrvalidationerrors = [];
  availableContests;
  selectedDefinitionCd: string[] = [];
  isAdvanceSearchVisibile: boolean;
  isAdvanceSearchDialogVisible: boolean;
  requestSeq;
  fullPath;
  labelKey;
  advanceSearchFields = [];
  allowedLabels = ['productName', 'lob', 'recordType'];
  selectedRows: any[] = [];
  public isLeader: boolean;
  constructor(
    public service: GamificationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, router, headerService);
    this.submitted = false;
    this.isAdvanceSearchVisibile = false;
    this.isAdvanceSearchDialogVisible = false;
    this.isLeader = false;
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'simple_numbers',
      pageLength: 10,
      dom: 'rtip',
      searching: false,
      lengthChange: true,
      responsive: true,
      destroy: true,
    } as any;

    // this.dtTrigger.next();
    this.requestSeq = this.route.snapshot.paramMap.get('id');
    const pathSegments = this.route.snapshot.url;
    this.fullPath = pathSegments.map((segment) => segment.path).join('/');
    const inputLabel = this.fullPath.split('-')[0];
    this.labelKey = inputLabel.charAt(0).toUpperCase() + inputLabel.slice(1);
    if (this.requestSeq != null || this.requestSeq != undefined) {
      this.showTable = true;
      this.submitted = true;
    }
    this.getLookupList();
    this.getSearchList();
    this.getBreadCrumbList();
    let userLoginData = undefined;
    if (sessionStorage.getItem('userLoginData') != undefined) {
      userLoginData = JSON.parse(sessionStorage.getItem('userLoginData'));
    }
    for (const role of userLoginData['userRoleList']) {
      if (role != 'AGENT') {
        this.isLeader = true;
        break;
      }
    }
    super.ngOnInit();
  }

  isNumeric(value: any): boolean {
    return value !== null && value !== '' && !isNaN(+value);
  }

  formatNumber(value: any): string {
    if (value === null || value === '' || isNaN(value)) return value;

    const numberValue = +value;

    if (Number.isInteger(numberValue)) {
      return numberValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    return numberValue.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  get isSearchDisabled(): boolean {
    const basicFiltersEmpty = !this.filterType && !this.rankType && !this.rankCount;
    const advancedFiltersEmpty = !this.advanceSearchFields?.some((field) => !!field.model);
    return basicFiltersEmpty && advancedFiltersEmpty;
  }

  getLookupList() {
    const searchText =
      this.labelKey == 'Incentive'
        ? 'INCENTIVEDEFINITIONNAME'
        : this.labelKey == 'Contest'
        ? 'CONTESTDEFINITIONNAME'
        : this.labelKey == 'Commission'
        ? 'COMMISSIONDEFINITIONNAME'
        : '';

    this.service.getLookupList(searchText).subscribe((lookupList) => {
      let respData = JSON.parse(JSON.stringify(lookupList));
      const values = respData?.data?.values || [];
      this.availableContests = values.map((item: any) => ({
        label: item.desc,
        value: item.cd,
      }));
    });
  }

  search() {
    this.closeAdvanceSearch();
    const basicFilters = {
      filterType: this.filterType,
      rankType: this.rankType,
      rankCount: this.rankCount,
    };

    const advancedFilters = this.advanceSearchFields.reduce((acc, field) => {
      acc[field.metadata] = field.model ?? null;
      return acc;
    }, {} as any);

    const combinedFilters = {
      ...basicFilters,
      ...advancedFilters,
    };

    this.getSearchList(combinedFilters);
    this.showTable = true;
  }

  rerenderDataTable(): void {
    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        // this.dtTrigger.next();
      });
    }
  }

  getSearchList(combinedFilters?) {
    this.service.getSearchList('SearchProposalListing', true, combinedFilters).subscribe((response: any) => {
      const jsonData = response?.data?.searchResultInfo || {};
      const searchResultData = response?.data?.searchResultData || [];

      // Sort fields based on position
      const fields = Object.values(jsonData)
        .filter((item: any) => item.LABELKEY && item.position != null)
        .sort((a: any, b: any) => a.position - b.position);

      const labelKeys = fields.map((item: any) => item.LABELKEY);
      this.headers = this.showTable ? ['Select', ...labelKeys] : [...labelKeys];

      // Map data rows to objects using sorted fields
      if (this.showTable) {
        this.filteredData = searchResultData.map((row: any[]) => {
          const rowObj: any = {};
          fields.forEach((field, index) => {
            rowObj[field['LABELKEY']] = row[index];
          });
          return rowObj;
        });
        this.rerenderDataTable();
        this.dtTrigger.next(null);
      }

      this.advanceSearchFields = [];
      fields
        .filter((item: any) => this.allowedLabels.includes(item.LABELKEY))
        .forEach((item: any) => {
          const type =
            item.INPUTTYPECD === 'COMBO' || item.INPUTTYPECD === 'FCOMBO' || item.INPUTTYPECD === 'LOOKUPTEXT'
              ? 'select'
              : item.INPUTTYPECD === 'DATE' || item.INPUTTYPECD === 'DATETIME'
              ? 'date'
              : 'text';

          if (type === 'select' && (item.LABELKEY === 'productName' || item.LABELKEY === 'recordType')) {
            // const searchText = 'PRODUCTCD';
            const searchText = item.LOOKUPCD;
            this.service.getLookupList(searchText).subscribe((lookupList) => {
              let lookupDataList = JSON.parse(JSON.stringify(lookupList));
              const values = lookupDataList?.data?.values || [];
              const options = values.map((v: any) => ({
                value: v.cd,
                label: v.desc,
              }));
              this.advanceSearchFields.push({
                label: item.LABELKEY,
                metadata: item.metadata,
                type,
                model: '',
                options,
              });
            });
          } else {
            const options =
              type === 'select'
                ? Array.from(
                    new Set(
                      searchResultData.map((row: any[]) => row[item.position - 1]).filter((val) => val != null)
                    )
                  ).sort()
                : [];

            this.advanceSearchFields.push({
              label: item.LABELKEY,
              metadata: item.metadata,
              type,
              model: '',
              options,
            });
          }
        });
    });
  }

  onDateChange(field: any) {
    const input = field.model;
    const displayFormat = SettingService.getSystemDateFormat();
    const formatted = formatDate(input, displayFormat, 'en-IN');
    field.model = formatted;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    const breadcrumbs = [
      {
        id: 'Home',
        link: '/home',
      },
      ...(this.requestSeq != undefined
        ? [
            {
              id: this.labelKey + ' ' + this.settingService.getLabelValue('gamificationInquiry'),
              link: '/' + this.labelKey.toLowerCase() + '-inquiry',
            },
          ]
        : []),
      {
        id: this.labelKey + ' ' + this.settingService.getLabelValue('gamificationRequest'),
      },
    ];
    return breadcrumbs;
  }

  isFilterActive(): boolean {
    return !!(this.filterType || this.rankType || this.rankCount || this.advanceSearchFields);
  }

  resetFilters() {
    this.filterType = '';
    this.rankType = '';
    this.rankCount = null;
  }

  onSelectionChange() {
    this.selectedRows = this.filteredData.filter((row) => row.selected);
  }

  submitContests() {
    if (!this.selectedDefinitionCd || this.selectedDefinitionCd.length === 0) {
      alert('Please select at least one ' + this.labelKey + '  from the dropdown');
      return;
    }
    if (!this.selectedRows || this.selectedRows.length == 0) {
      alert('Please select at least one proposal for gamification!');
      return;
    }
    const definitionCd = this.selectedDefinitionCd.join(',');
    let definitionType = this.labelKey.toUpperCase();
    let filterCriteria = this.filterType;
    let proposalDetails = this.selectedRows;
    this.service.saveGamificationRequest(definitionCd, definitionType, filterCriteria, proposalDetails).subscribe(
      (response) => {
        this.submitted = true;
        this.arrvalidationerrors.push('Your request in in progress, please check status on inquiry section');
        this.openModal('errorModal');
      },
      (error) => {
        console.log('error', error);
      }
    );
  }

  /**
   * This close the Error modal
   */
  closeErrorModal() {
    this.closeModal('errorModal');
  }

  navigateToInquiry() {
    this.router.navigate(['/incentive-inquiry']);
    this.closeErrorModal();
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.labelKey + ' ' + this.settingService.getLabelValue('gamificationRequest');
    return header;
  }

  onAdvanceSearchClicked() {
    this.isAdvanceSearchVisibile = true;
    this.isAdvanceSearchDialogVisible = true;
  }

  closeAdvanceSearch(): void {
    this.isAdvanceSearchVisibile = false;
    this.isAdvanceSearchDialogVisible = false;
  }

  applyAdvanceSearch(): void {
    const filters = this.advanceSearchFields.reduce((acc, field) => {
      if (field.model) acc[field.label] = field.model;
      return acc;
    }, {} as any);

    this.closeAdvanceSearch();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    if (this.dtElement?.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
      });
    }
  }
}
